
import {Component, Vue, Watch} from "vue-property-decorator";
import {Route} from "vue-router";
import {Dictionary} from "vue-router/types/router";

import api from "@/api";
import {OrganizationUnitDto, OrganizationUnitLevel} from "../api/appService";
import {removeOu} from "@/utils/cookies";
import {createNgTree, INgNode, ngTreeToDictionary, setNgNodeProperty} from "@/utils/tree";
import {ancestorWhere} from "tslint";

interface IAddedOrganizationUnit {
  organizationUnit: OrganizationUnitDto;
  hasPermission: boolean
}

@Component({
  name: "SelectStore",
  components: {},
  filters: {
    level(level: number) {
      switch (level) {
        case 1:
          return "总部";
        case 2:
          return "大区";
        case 4:
          return "片区";
        case 8:
          return "门店";
        default:
          return "未分配";
      }
    }
  }
})
export default class extends Vue {
  baseOu: OrganizationUnitDto = {
    parentId: undefined,
    status: 1,
    level: OrganizationUnitLevel.总部,
    displayName: "童萌总部",

    id: -1,
    detail: {logoImgUrl: "/img/default.b00ca915.png"}
  };

  storeList: OrganizationUnitDto[] = [];
  allOrgList: OrganizationUnitDto[] = [];

  isadmin: boolean = false;
  treeData: INgNode<OrganizationUnitDto>[] = [];
  defaultExpandedKeys: number[] = [];
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};

  loading = true;


  created() {

  }

  async loadAllOrgList() {
    await api.organizationUnit.getOrganizationUnitsOfDescendant({orgId: undefined}).then(res => {
      this.allOrgList = res;
    })
  }

  async mounted() {

    if (this.allOrgList.length === 0) {
      console.log('allOrgList is empty when mounted')
      await this.loadAllOrgList();
    }

    this.loading = true;
    if (this.$store.getters['user/isAdmin'] || this.$store.getters['user/isHeadquarter']) {
      this.isadmin = true;
      this.storeList.push(this.baseOu);
    }

    api.organizationUnit.getOrganizationUnits().then(res => {
      this.storeList = [...this.storeList, ...res.items!];
      let tree: INgNode<OrganizationUnitDto>[];
      if (this.isadmin) {

        tree = createNgTree(
          this.storeList,
          'parentId',
          'id', null,
          'children',
          undefined,
          false,
          'id'
        );
        tree = [{
          children: tree,
          disabled: false,
          label: this.baseOu.displayName!,
          isLeaf: false,
          id: this.baseOu.id,
          expanded: true,
          hidden: false,
          parentNode: undefined,
          key: '',
          data: this.baseOu
        }
        ]
      } else {
        tree = this.convertToOuTree(this.storeList);
      }

      console.log(this.storeList);
      console.log(tree);
      this.treeData = tree;
      if (!tree || tree.length === 0) {
        console.log(this.allOrgList);
      }

      this.defaultExpandedKeys = this.treeData.map(x => x.id);
      console.log('defaultExpandedKeys', this.defaultExpandedKeys,this.treeData);

      this.loading = false;
    });
  }

  @Watch("$route", {immediate: true})
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  handleSelect(store: OrganizationUnitDto) {
    console.log(store);
    this.$store.dispatch('user/changeOu', store)
    this.$message.success("切换门店成功,正在跳转中");
    setTimeout(() => {
      this.$router.push({
        path: this.redirect || "/",
        query: this.otherQuery
      });
    }, 1000);
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== "redirect") {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as Dictionary<string>);
  }

  private handleLogin() {
  }

  private convertToOuTree(assignedOrganizationUnits: OrganizationUnitDto[]) {

    let rootNodes = createNgTree(
      this.allOrgList,
      'parentId',
      'id',
      null,
      'children',
      null,
      true,
      'id');

    const allNodes = ngTreeToDictionary(rootNodes);
    setNgNodeProperty(rootNodes, s => {
      s.hidden = true;
      s.disabled = true;
    });

    assignedOrganizationUnits.forEach(assign => {
      let node = allNodes[assign.id!.toString()];
      if (!node) {
        return;
      }
      node.disabled = false;
      node.hidden = false;
      let parentNode = node.parentNode;
      while (parentNode) {
        parentNode.hidden = false;
        parentNode = parentNode.parentNode;
      }
      if (node.children) {
        setNgNodeProperty(node.children, (child) => {
          child.disabled = false;
          child.hidden = false;
        })
      }
    });
    return this.resetNodes(rootNodes);
  }

  resetNodes(nodes: INgNode<OrganizationUnitDto>[]) {
    const result: INgNode<OrganizationUnitDto>[] = [];
    nodes.forEach(item => {
      if (!item.hidden) {
        result.push(item);
      }
      if (item.children) {
        item.children = this.resetNodes(item.children);
      }


    });


    return result;
  }


  firstOrDefault<T>(array: T[], predicate: (arg: T) => boolean) {
    for (let i = 0, len = array.length; i < len; i++) {
      let value = array[i];
      if (predicate(value)) {
        return value;
      }
    }
    return undefined;
  }


  async logout() {
    this.$store.commit('user/LOGOUT');
    this.$router.push({path: '/account/login'})
  }

  nodeclick(item: any) {
    console.log(item);
  }
}
